import { createReducer, on } from '@ngrx/store';
import { HttpError, TransactionStatus } from '@rd/types';
import { CashbackFormData } from '../../types';
import * as actions from '../actions/cashback.actions';

// TODO: Move this interface into shared types
export interface CashbackState {
  formData: CashbackFormData | null;
  cashback: {
    status: TransactionStatus;
    error: HttpError | null;
  };
}

export const initialState: CashbackState = {
  formData: null,
  cashback: {
    status: TransactionStatus.INITIAL,
    error: null,
  },
};

export const cashbackReducer = createReducer(
  initialState,
  on(actions.SubmitCashbackForm, (state, action) => ({
    ...state,
    formData: {
      ...action.formData,
    },
  })),
  on(actions.SubmitCashback, (state) => ({
    ...state,
    cashback: {
      error: null,
      status: TransactionStatus.LOADING,
    },
  })),
  on(actions.SubmitCashbackSuccess, (state) => ({
    ...state,
    formData: null,
    cashback: {
      status: TransactionStatus.SUCCESS,
      error: null,
    },
  })),
  on(actions.SubmitCashbackFail, (state, { type, ...payload }) => ({
    ...state,
    cashback: {
      status: TransactionStatus.FAIL,
      error: payload,
    },
  })),
  on(actions.ClearCashbackError, (state) => ({
    ...state,
    cashback: {
      status: TransactionStatus.INITIAL,
      error: null,
    },
  })),
  on(
    actions.HydrateCashback,
    (
      state,
      {
        hydrationData: {
          data: { redemptionAmount, cashAmount },
        },
      },
    ) => ({
      ...state,
      formData: {
        sourceAmount: redemptionAmount,
        targetAmount: cashAmount,
      },
    }),
  ),
);
